'use client';

import { c as _c } from "react/compiler-runtime";
import './sac-list-spotlight.scss';
import { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRandomChildren } from '@sola/proxy-sdk/children.ts';
import { ChildAvailabilityItem } from '@sola/schema/dotcom/children/child.ts';
import { SacFilterProps } from '@sola/schema/lib/schema.ts';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.ts';
import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { SacCard } from '../../../molecules/sac-card/sac-card.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
import { ChildBioSkeleton } from '../../child-bio/child-bio-skeleton';
export const SacSpotlight: React.FC<SacFilterProps> = t0 => {
  const $ = _c(36);
  let body;
  let props;
  let t1;
  let title;
  if ($[0] !== t0) {
    ({
      seoLevel: t1,
      title,
      body,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = body;
    $[2] = props;
    $[3] = t1;
    $[4] = title;
  } else {
    body = $[1];
    props = $[2];
    t1 = $[3];
    title = $[4];
  }
  const seoLevel = t1 === undefined ? 2 : t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["bio", "core"];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    t
  } = useTranslation(t2);
  const [childData, setChildData] = useState();
  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);
  let t3;
  if ($[6] !== props) {
    t3 = props || {};
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    mergeFieldData: t4
  } = t3;
  let t5;
  if ($[8] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    richmixChildData
  } = t5;
  let t6;
  if ($[10] !== richmixChildData) {
    t6 = () => {
      if (richmixChildData) {
        setChildData(richmixChildData);
        return;
      }
      const getChildData = async () => {
        const response = await getRandomChildren();
        setChildData(response?.children[0]);
      };
      getChildData();
    };
    $[10] = richmixChildData;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  useEffect(t6, t7);
  const t8 = "SacListSpotlight component";
  const T0 = Suspense;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChildBioSkeleton />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = "container md:grid flex flex-col md:grid-cols-2 items-center gap-comfy-xl";
  const t11 = "flex flex-col gap-comfy-sm md:gap-comfy-lg";
  const T1 = FeatureBase;
  const t12 = getBaseSizeProps(headerDisplayLevel);
  const t13 = seoLevel === 1 ? "xxl" : "xl";
  let t14;
  if ($[14] !== childData || $[15] !== t) {
    t14 = childData && {
      title: t("bio:title", {
        childName: childData.name.preferred
      }).replace(/[!.?,:;]/g, ""),
      link: `/sponsor-a-child/child-bio?gid=${childData.globalId}&source=${childData.sourceCode}`
    };
    $[14] = childData;
    $[15] = t;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== T1 || $[18] !== body || $[19] !== seoLevel || $[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== title) {
    t15 = <div className={t11}><T1 {...t12} seoLevel={seoLevel} titleSize={t13} title={title} body={body} className="pb-comfy-sm" variantResponsive={true} inline={true} primaryCTA={t14} /></div>;
    $[17] = T1;
    $[18] = body;
    $[19] = seoLevel;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = title;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== childData) {
    t16 = childData && <SacCard {...childData} />;
    $[25] = childData;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16) {
    t17 = <aside className="SacListSpotlight__child-container w-full">{t16}</aside>;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t15 || $[30] !== t17) {
    t18 = <div className={t10}>{t15}{t17}</div>;
    $[29] = t15;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== T0 || $[33] !== t18 || $[34] !== t9) {
    t19 = <section className={t8}><T0 fallback={t9}>{t18}</T0></section>;
    $[32] = T0;
    $[33] = t18;
    $[34] = t9;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  return t19;
};